<!--调拨单入仓 -->
<template>
    <div class="warehouseOut" v-loading="dailogLoading">
        <div class="dialog-header">
            <div>
                <el-button v-if="!isTcckModel" class="btn-primary" size="small" @click="isTcckModel = true">同仓入库</el-button>
                <el-select
                    v-if="isTcckModel"
                    v-model="tcckWarehouseId"
                    size="small"
                    filterable
                    clearable
                    disabled
                    @visible-change="track_wHVisibleChange($event)"
                    @change="
                        val => {
                            (tcckShelfSpaceId = ''), (tcckShelfSpaceOptions = []);
                        }
                    "
                    style="margin-right: 20px"
                >
                    <el-option v-for="optionItem in tcckWarehouseList" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId" :key="optionItem.WarehouseId"> </el-option>
                </el-select>
                <el-select
                    v-if="isTcckModel"
                    v-model="tcckShelfSpaceId"
                    :loading="loading"
                    filterable
                    clearable
                    reserve-keyword
                    remote
                    :remote-method="value => tcrkRemoteMethod(value, tcckWarehouseId)"
                    @visible-change="
                        value => {
                            if (value && tcckShelfSpaceOptions.length == 0) tcrkRemoteMethod('', tcckWarehouseId);
                        }
                    "
                    @change="tcckShelfSpaceChange"
                    size="small"
                >
                    <el-option v-for="item in tcckShelfSpaceOptions" :key="item.ShelfSpaceId" :label="item.ShelfSpaceCode" :value="item.ShelfSpaceId"> </el-option>
                </el-select>
            </div>
            <div v-if="isTcckModel">
                <el-button size="small" @click="isTcckModel = false">取消</el-button>
                <el-button class="btn-primary" size="small" @click="submitData">入仓</el-button>
            </div>
        </div>
        <div class="tips">整单商品只能入库到同一仓位下</div>
        <div class="warehouseOut-main">
            <ux-grid ref="refTable" :data="goodsList" border style="width: 100%; margin: 0" height="550px" :header-cell-style="{ background: '#F2F6FC' }">
                <ux-table-column class-name="table-sort" type="index" title="序号" width="60" resizable></ux-table-column>
                <ux-table-column class-name="table-sort" field="GoodName" title="配件名称" width="170" key="2"></ux-table-column>
                <ux-table-column class-name="table-sort" field="APCode" title="配件编码" width="170" key="3"></ux-table-column>
                <ux-table-column class-name="table-sort" field="WarehouseName" title="仓库" key="4"></ux-table-column>
                <ux-table-column field="ShelfSpaceId" title="仓位" key="5">
                    <template slot-scope="scope">
                        <el-select
                            v-model="scope.row.ShelfSpaceId"
                            value-key="ShelfSpaceId"
                            :loading="loading"
                            filterable
                            clearable
                            reserve-keyword
                            remote
                            :remote-method="val => remoteMethod(val, scope.row)"
                            @change="positionChange($event, scope.row)"
                            @visible-change="positionVisibleChange($event, scope.row)"
                            @clear="positionClear(scope.row)"
                            no-data-text="无存放仓位"
                            no-match-text="无存放仓位"
                            size="small"
                            :disabled="isTcckModel"
                        >
                            <el-option
                                :key="optionItem.ShelfSpaceId"
                                v-for="optionItem in scope.row.ShelfSpacesList"
                                :label="optionItem.ShelfSpaceCode"
                                :value="optionItem.ShelfSpaceId"
                            >
                                <span style="display: inline-block; width: 150px">{{ optionItem.ShelfSpaceCode }}</span>
                                <span v-if="!isNaN(optionItem.Count)">库存:{{ optionItem.Count }}</span>
                            </el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="Count" title="数量" key="6">
                    <template slot-scope="scope">
                        <el-input :disabled="isTcckModel" size="small" type="number" v-model="scope.row.Count" :min="0" />
                    </template>
                </ux-table-column>
                <ux-table-column width="80" class-name="table-sort" v-if="isTcckModel" field="Count" title="库存数" key="7">
                    <template slot-scope="scope">
                        {{ scope.row.KcCount }}
                    </template>
                </ux-table-column>
                <ux-table-column title="操作" key="8" class-name="operc">
                    <template slot-scope="scope">
                        <el-button size="mini" icon="el-icon-minus" @click="delItem(scope.$rowIndex, scope.row)"> </el-button>
                        <el-button size="mini" icon="el-icon-plus" @click="addItem(scope.$rowIndex, scope.row)"> </el-button>
                    </template>
                </ux-table-column>
            </ux-grid>
        </div>
        <div class="dialog-footer" v-if="!isTcckModel">
            <el-button size="small" @click="cancel">取消</el-button>
            <el-button class="btn-primary" size="small" @click="submitData">提交入仓</el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['EntpTOId'],
    components: {},
    data() {
        return {
            loading: false,
            dailogLoading: true,
            searchPositionReq: {
                WarehouseId: '',
                ShelfSpaceCode: '',
                GoodsId: '',
                SortField: 'Count',
                SortType: 'asc',
                MustIn: false,
                Page: 1,
                Limit: 10
            },
            formData: {
                TOId: this.EntpTOId,
                GoodsList: [
                    {
                        EntpTempGoodsId: '',
                        Count: 0,
                        GoodsLocationList: [
                            {
                                ShelfSpaceId: '',
                                Count: ''
                            }
                        ]
                    }
                ]
            },
            goodsList: [],

            isTcckModel: false, // 是否开启同仓入库模式
            tcckWarehouseId: '', // 同仓入库仓库信息
            tcckShelfSpaceId: '', // 同仓入库仓位信息
            tcckWarehouseList: [],
            tcckShelfSpaceOptions: [] // 同仓入库仓位列表
        };
    },
    mounted() {
        this.getTODetail();
        this.track_wHVisibleChange(true);
    },
    methods: {
        checkCount(count, max) {
            if (count > max) {
                this.$util.warningMsg('数量不得大于库存数量');
            }
        },
        cancel() {
            this.$emit('closeDialog');
        },
        submitData() {
            let that = this;
            let _data = [];
            for (let i = 0; i < that.goodsList.length; i++) {
                let row = that.goodsList[i];
                if (!row.ShelfSpaceId) {
                    that.$util.warningMsg('请选择仓位');
                    return;
                }
                if (row.Count <= 0) {
                    that.$util.warningMsg('入库数量必须大于零');
                    return;
                }
                let PV = row.Count;
                let EV = that.goodsList.filter(f => f.EntpTempGoodsId == row.EntpTempGoodsId).reduce((r, i) => r + i.Count * 1, 0);
                // if (row.canOutCount < EV) {
                //     that.$util.warningMsg('入库数量不可以超过未入库数量');
                //     return;
                // }
                // if (PV != EV) {
                //     this.$util.warningMsg('入库数量与待入库数量填写不相等');
                //     return;
                // }
                if (row.CountMax != EV) {
                    this.$util.warningMsg('入库数量与待入库数量填写不相等');
                    return;
                } 
                let intCount = Number(row.Count);
                let goods = _data.find(f => f.EntpTempGoodsId == row.EntpTempGoodsId);
                if (goods) {
                    goods.GoodsLocationList.push({
                        ShelfSpaceId: row.ShelfSpaceId,
                        Count: intCount
                    });
                } else {
                    goods = {
                        EntpTempGoodsId: row.EntpTempGoodsId,
                        GoodsLocationList: [{ ShelfSpaceId: row.ShelfSpaceId, Count: intCount }]
                    };
                    _data.push(goods);
                }
            }
            this.dailogLoading = true;
            this.formData.GoodsList = _data;
            this.$util
                .axiosPost({
                    url: '/api/EntpTransferOrder/SubmitTransOrderWarehouseIn',
                    data: this.formData
                })
                .then(res => {
                    if (res.errcode == 0) {
                        this.$util.successMsg(res.errmsg);
                        this.$store.commit('updateNeedRefresh', true);
                        this.$emit('closeDialog', true);
                    } else this.$util.errorMsg(res.errmsg);
                })
                .catch(() => {
                    this.dailogLoading = false;
                });
        },
        positionVisibleChange(val, goods) {
            if (!val || !goods.WarehouseId) return;
            let that = this;
            if (!(goods.ShelfSpacesList && goods.ShelfSpacesList.length > 0)) {
                that.searchPositionReq.WarehouseId = goods.WarehouseId;
                that.searchPositionReq.ShelfSpaceCode = '';
                that.searchPositionReq.GoodsId = goods.EntpTempGoodsId;
                that.searchPositionReq.Page = 1;
                that.searchPosition(that.searchPositionReq).then(resp => {
                    let newArr = [];
                    if (resp.data) newArr = resp.data;
                    that.$set(goods, 'ShelfSpacesList', newArr);
                    that.loading = false;
                });
            }
        },
        remoteMethod(val, goods) {
            if (!val || !goods.WarehouseId) return;
            let that = this;
            that.searchPositionReq.WarehouseId = goods.WarehouseId;
            that.searchPositionReq.ShelfSpaceCode = val;
            that.searchPositionReq.GoodsId = goods.EntpTempGoodsId;
            that.searchPositionReq.Page = 1;
            that.searchPosition(that.searchPositionReq).then(resp => {
                let newArr = [];
                if (resp.data) newArr = resp.data;
                that.$set(goods, 'ShelfSpacesList', newArr);
                that.loading = false;
            });
        },
        searchPosition(req) {
            let that = this;
            if (!req.WarehouseId || that.loading) return;
            that.loading = true;
            return that.$util.getPositionByGId(that.searchPositionReq);
        },
        positionChange(value, goods) {
            if (!value) return;
            var that = this;
            var filterArr = that.goodsList.filter(e => e.EntpTempGoodsId == goods.EntpTempGoodsId && e.ShelfSpaceId == value);
            if (filterArr.length > 1) {
                goods.ShelfSpaceId = '';
                this.$util.warningMsg('不能选相同仓位');
                return;
            }
            if (this.isTcckModel) {
                let idx = goods.ShelfSpacesList.findIndex(f => f.ShelfSpaceId === value);
                goods.KcCount = goods.ShelfSpacesList[idx].Count;
            }
        },
        delItem(index, goods) {
            let that = this;
            var filterArr = that.goodsList.filter(e => e.EntpTempGoodsId == goods.EntpTempGoodsId);
            if (filterArr.length > 1) {
                that.goodsList.splice(index, 1);
                that.getSpanArr();
            }
        },
        addItem(index, goods) {
            let that = this;
            let _target = that.goodsList;
            let usedCount = 0; //已选数量
            for (let i = 0; i < _target.length; i++) {
                if (_target[i].EntpTempGoodsId == goods.EntpTempGoodsId) {
                    if (!_target[i].ShelfSpaceId) {
                        that.$util.warningMsg('请选择仓位');
                        return;
                    }
                    if (!_target[i].Count || !_target[i].Count < 0) {
                        that.$util.warningMsg('请填写正确的数量');
                        return;
                    }
                    usedCount += Number(_target[i].Count);
                }
            }
            //当前商品可出库数量
            let canInCount = Number(goods.Count);
            //剩余数量
            let surplus = canInCount - usedCount;
            that.goodsList.splice(index + 1, 0, {
                EntpTempGoodsId: goods.EntpTempGoodsId,
                GoodName: goods.GoodName,
                APCode: goods.APCode,
                Count: surplus > 0 ? surplus : 0,
                WarehouseId: goods.WarehouseId,
                WarehouseName: goods.WarehouseName,
                ShelfSpaceId: '',
                ShelfSpacesList: [],
                CountMax:goods.CountMax,
            });
            that.getSpanArr();
        },
        getSpanArr() {
            this.spanArr = [];
            this.pos = 0;
            for (var i = 0; i < this.goodsList.length; i++) {
                if (i === 0) {
                    this.spanArr.push(1);
                    this.pos = 0;
                } else {
                    // 判断当前元素与上一个元素是否相同
                    if (this.goodsList[i].EntpTempGoodsId === this.goodsList[i - 1].EntpTempGoodsId) {
                        this.spanArr[this.pos] += 1;
                        this.spanArr.push(0);
                    } else {
                        this.spanArr.push(1);
                        this.pos = i;
                    }
                }
            }
        },
        getTODetail() {
            this.$util
                .axiosGet({
                    url: '/api/EntpTransferOrder/GetTransOrderDetailsInContainWH',
                    data: {
                        TOId: this.EntpTOId
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    let _APList = [];
                    for (let i = 0; i < data.DetailList.length; i++) {
                        data.DetailList[i].CountMax = data.DetailList[i].Count;
                        data.DetailList[i].ShelfSpaceId = '';
                        data.DetailList[i].ShelfSpacesList = [];
                        _APList.push(data.DetailList[i]);
                    }
                    this.goodsList = _APList;
                    this.dailogLoading = false;
                });
        },
        track_wHVisibleChange(val) {
            if (!val || this.tcckWarehouseList.length > 0) return;
            this.$util.getWarehouse().then(data => {
                this.tcckWarehouseList = data;
                setTimeout(() => {
                    if (this.goodsList.length !== 0) {
                        this.tcckWarehouseId = this.goodsList[0].WarehouseId;
                    }
                }, 200);
            });
        },
        // 同仓出库搜索仓位
        tcrkRemoteMethod(value, tcckWarehouseId) {
            if (!tcckWarehouseId) return;
            let that = this;
            that.loading = true;
            that.$util
                .GetShelfSpacesList({
                    WarehouseId: tcckWarehouseId,
                    ShelfSpaceCode: value,
                    Limit: 20,
                    IsLimit: true,
                    IncludecWaste: true
                })
                .then(res => {
                    that.loading = false;
                    if (res.data) {
                        that.tcckShelfSpaceOptions = res.data;
                    } else {
                        that.$util.warningMsg('该仓库暂无仓位');
                    }
                })
                .catch(error => {
                    that.loading = false;
                });
        },
        // 同仓出库选择仓位
        async tcckShelfSpaceChange(key) {
            this.dailogLoading = true;
            const { data } = await this.$util.axiosPost({
                url: '/api/EntpShelfSpaces/GetGoodsInSpaceCount',
                data: {
                    shelfSpaceId: key,
                    goodsIds: this.goodsList.map(m => m.EntpTempGoodsId)
                },
                hideLoading: true
            });
            this.dailogLoading = false;
            /**
             * 展示库存数
             * 去除重复商品项
             * 用同库出仓选择的数据，覆盖仓库，仓库列表，仓位，仓位列表
             */
            let _goodsList = [];
            this.goodsList.forEach(ele => {
                if (_goodsList.findIndex(f => f.EntpTempGoodsId === ele.EntpTempGoodsId) === -1) {
                    let gIdx = data.findIndex(f => f.GoodsId === ele.EntpTempGoodsId);
                    let tIdx = this.tcckShelfSpaceOptions.findIndex(f => f.ShelfSpaceId === key);
                    let param = {
                        ...ele,
                        WarehouseId: this.tcckWarehouseId,
                        ShelfSpaceId: this.tcckShelfSpaceId,
                        KcCount: gIdx > -1 ? data[gIdx].Count : 0,
                        ShelfSpacesList: []
                    };
                    if (this.tcckShelfSpaceOptions[tIdx]) {
                        param.ShelfSpacesList = [
                            {
                                ...this.tcckShelfSpaceOptions[tIdx],
                                Count: gIdx > -1 ? data[gIdx].Count : 0
                            }
                        ];
                    }
                    _goodsList.push(param);
                }
            });
            this.goodsList = _goodsList;
        },
        positionClear(goods) {
            goods.ShelfSpacesList = [];
        }
    }
};
</script>
<style lang="less" scoped>
.dialog-header {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.tips {
    color: #f00;
    margin-top: 4px;
    margin-left: 4px;

}
.add-btn {
    position: absolute;
    right: 10px;
    bottom: 6px;
}
.ops-ctn {
    text-align: left !important;
}
.dialog-footer {
    text-align: right;
    margin-top: 0px;
}
.warehouseOut-main {
    padding-top: 10px;
    padding-bottom: 10px;
}
.table-title {
    .cell-item {
        width: 33.33%;
    }
    .div-table-cell {
        text-align: center;
        height: 30px;
        line-height: 30px;
    }
}
.div-table-row {
    position: relative;
    overflow: visible;
}
.table-main {
    .div-table-cell {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }
    .cell-line {
        display: flex;
        width: 100%;
    }
    .cell-item {
        padding: 0 10px;
        width: 33%;
        width: inherit;
        text-align: center;
        height: 40px;
        line-height: 40px;
    }
}
</style>
